import { render } from "./MediaDisplay.vue?vue&type=template&id=08a41470&scoped=true"
const script = {}

import "./MediaDisplay.vue?vue&type=style&index=0&id=08a41470&lang=scss&scoped=true"

import exportComponent from "/Users/iti/Documents/icandy_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a41470"]])

export default __exports__